const buildURLFingerprinting = ({ url = '', lastEditedDate = '', queryStr = '?' }) => {
  const time = new Date(lastEditedDate).getTime();

  return time ? `${url}${queryStr}lastEditedDate=${time}` : url;
};

export { buildURLFingerprinting };



// WEBPACK FOOTER //
// ./shared/utils/UrlUtils.js